export default __webpack_public_path__ + "static/media/mini-code.63c4d73c.jpg";